import * as React from 'react';
import Markdown from './Markdown';
import { Accordion as MuiAccordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material';
import { ArrowDownIcon } from './Icons';

const Accordion = (props) => {

  const { data, bodyVariant, ...others } = props;
  const variant = bodyVariant ? bodyVariant : 'body1';

  return (
    <MuiAccordion
      {...others}
    >
      <AccordionSummary
        expandIcon={<ArrowDownIcon color="dark" />}
      >
        <Typography component="h3" color="textPrimary" fontSize="inherit"><b>{data.title}</b></Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography component={Markdown} color="textPrimary" variant={variant}>
          {data.body}
        </Typography>
      </AccordionDetails>
    </MuiAccordion>
  );
}

export default Accordion;